"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("./../api/WickedApiClient");
var platform_browser_1 = require("@angular/platform-browser");
var i0 = require("@angular/core");
var i1 = require("@angular/platform-browser");
var i2 = require("../api/WickedApiClient");
var i3 = require("@angular/common");
var SeoService = /** @class */ (function () {
    function SeoService(meta, title, seoClient, dom) {
        this.meta = meta;
        this.title = title;
        this.seoClient = seoClient;
        this.dom = dom;
        this.defaultData = { title: "Wickedlist.com - long term relationship or casual dating!", description: "Wickedlist - free adult personal classifieds: long term relationship and casual dating. Find love or casual thing for straight, gay, trans, couples in the US!" };
        this.seoData = {
            0: this.defaultData,
            1: { title: "Woman seek man - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Woman seeking a man on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            2: { title: "Woman seek woman - free dating in US | Wickedlist.com", description: "\u2764 Woman seeking a woman on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            3: { title: "Woman seek couple - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Woman seeking a couple on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            4: null,
            5: { title: "Man seek woman - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Man seeking a woman on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            6: { title: "Man seek man - free dating in US | Wickedlist.com", description: "\uD83D\uDD25 Man seeking a man on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            7: { title: "Man seeking couple - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Man seeking couple on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            8: { title: "", description: "" },
            9: { title: "Couple seek woman - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek woman on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            10: { title: "Couple seek man - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek man on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            11: { title: "Couple seek couple - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek couple on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            12: { title: "Couple seek threesome - free dating in US | Wickedlist.com", description: "\uD83D\uDC91 Couple seek third on site Wickedlist in US \uD83D\uDC95 Free adult personal classifieds \uD83D\uDC95Relationship long term \uD83D\uDECF\uFE0F Casual dating" },
            13: null,
            14: null,
            15: null,
            16: null,
            17: null,
        };
    }
    SeoService.prototype.toUTF16 = function (codePoint) {
        var TEN_BITS = parseInt('1111111111', 2);
        function u(codeUnit) {
            return '\\u' + codeUnit.toString(16).toUpperCase();
        }
        if (codePoint <= 0xFFFF) {
            return u(codePoint);
        }
        codePoint -= 0x10000;
        var leadSurrogate = 0xD800 + (codePoint >> 10);
        var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);
        return u(leadSurrogate) + u(tailSurrogate);
    };
    SeoService.prototype.updateMeta = function (title, description) {
        this.meta.updateTag({ name: 'description', content: description });
        this.title.setTitle(title);
    };
    SeoService.prototype.updateMetaDefaults = function () {
        this.updateMeta(this.defaultData.title, this.defaultData.description);
    };
    SeoService.prototype.updateMetaTagsBySearch = function (relationShipId) {
        if (this.seoData[relationShipId]) {
            var data = this.seoData[relationShipId];
            this.updateMeta(data.title, data.description);
        }
        else {
            this.updateMetaDefaults();
        }
    };
    SeoService.prototype.updateCanonicalLink = function (url) {
        var fullUrl = window.location.href;
        var arr = fullUrl.split("/");
        var domain = arr[0] + "//" + arr[2];
        var head = this.dom.getElementsByTagName('head')[0];
        var element = this.dom.querySelector("link[rel='canonical']") || null;
        if (element == null) {
            element = this.dom.createElement('link');
            head.appendChild(element);
        }
        element.setAttribute('rel', 'canonical');
        element.setAttribute('href', domain + url);
    };
    SeoService.prototype.removeCanonicalLink = function () {
        var element = this.dom.querySelector("link[rel='canonical']") || null;
        if (element != null) {
            element.remove();
        }
    };
    SeoService.prototype.getMetaSeo = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.seoClient.getMetaSeo(url).subscribe(function (result) {
                if (result.error && result.error != "") {
                    reject(result.error);
                }
                else
                    resolve(result);
            });
        });
    };
    SeoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SeoService_Factory() { return new SeoService(i0.ɵɵinject(i1.Meta), i0.ɵɵinject(i1.Title), i0.ɵɵinject(i2.SeoClient), i0.ɵɵinject(i3.DOCUMENT)); }, token: SeoService, providedIn: "root" });
    return SeoService;
}());
exports.SeoService = SeoService;
